import React, { useState } from "react";
import styled from "styled-components";

import TechSkills from "./skills/TechSkills";

const Hero = ({ theme }) => {
  const [title] = useState("full stack engineer");
  const [subtitles] = useState(["create", "break", "revive"]);

  return (
    <StyledHero>
      <Container>
        <InfoContainer>
          <TechSkills theme={theme} />

          <TitleContainer>
            <Title>{title}</Title>
          </TitleContainer>

          {subtitles.map((subtitle, idx) => (
            <Description key={idx}>{subtitle}</Description>
          ))}
        </InfoContainer>
      </Container>
    </StyledHero>
  );
};

export default Hero;

const StyledHero = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 93vh;
  width: 100vw;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: 850px) {
    flex-direction: column;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 850px) {
    text-align: center;
    align-items: center;
  }
`;

const TitleContainer = styled.h3`
  margin-top: 10px;
  margin-bottom: 16px;
  cursor: default;
`;

const Title = styled.a`
  font-size: 6vmin;
  font-weight: 909;
  color: ${({ theme }) => theme.accent};
  font-family: Verdana, Geneva, Tahoma, sans-serif;
`;

const Description = styled.div`
  text-align: center;
  font-weight: 100;
  font-size: 6vmin;
  width: 50%;
  cursor: default;
  @media (max-width: 850px) {
    width: 80%;
  }
`;
